import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import shiftClosingService from "../../../services/shiftClosingService";

const initialState = {
  openShift:      null,
  unclosedDates:  [],
  closings:       [],
  singleClosing:  null,
  isLoading:      false,
};

export const getOpenShift = createAsyncThunk(
  "shiftClosing/getOpen",
  async (_, t) => {
    try { return await shiftClosingService.getOpenShift(); }
    catch (e) { return t.rejectWithValue(e.response?.data?.message || e.message); }
  }
);

export const getUnclosedDates = createAsyncThunk(
  "shiftClosing/getUnclosed",
  async (_, t) => {
    try { return await shiftClosingService.getUnclosedDates(); }
    catch (e) { return t.rejectWithValue(e.response?.data?.message || e.message); }
  }
);

export const closeShift = createAsyncThunk(
  "shiftClosing/close",
  async (data, t) => {
    try { return await shiftClosingService.closeShift(data); }
    catch (e) { return t.rejectWithValue(e.response?.data?.message || e.message); }
  }
);

export const getShiftClosings = createAsyncThunk(
  "shiftClosing/getAll",
  async (_, t) => {
    try { return await shiftClosingService.getShiftClosings(); }
    catch (e) { return t.rejectWithValue(e.response?.data?.message || e.message); }
  }
);

export const getSingleShiftClosing = createAsyncThunk(
  "shiftClosing/getSingle",
  async (id, t) => {
    try { return await shiftClosingService.getSingleShiftClosing(id); }
    catch (e) { return t.rejectWithValue(e.response?.data?.message || e.message); }
  }
);

const shiftClosingSlice = createSlice({
  name: "shiftClosing",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getOpenShift.fulfilled, (state, action) => {
        state.openShift = action.payload;
      })
      .addCase(getUnclosedDates.fulfilled, (state, action) => {
        state.unclosedDates = action.payload.unclosedDates;
      })
      .addCase(closeShift.pending, (state) => { state.isLoading = true; })
      .addCase(closeShift.fulfilled, (state, action) => {
        state.isLoading = false;
        state.closings.unshift(action.payload);
        toast.success("Shift closed successfully");
      })
      .addCase(closeShift.rejected, (state, action) => {
        state.isLoading = false;
        toast.error(action.payload);
      })
      .addCase(getShiftClosings.fulfilled, (state, action) => {
        state.closings = Array.isArray(action.payload) ? action.payload : [];
      })
      .addCase(getSingleShiftClosing.fulfilled, (state, action) => {
        state.singleClosing = action.payload;
      });
  },
});

export default shiftClosingSlice.reducer;